import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 

import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReactToPrint from 'react-to-print';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import { styled } from '@mui/material/styles';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import Uploadfile from './Uploadfile';
import Payment from './Payment';

import PaymentRefBox from './Paymentdetails';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
	 import InfoSharpIcon from '@mui/icons-material/InfoSharp';          
 import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';




const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  

  table: {
    minWidth: 750,
  },
  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class VendorcreditnoteViewmore extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {
	 
	 outstandingamount:0,
	 open:false, addopen: false,redirect:false,pagename:'',PaymentArray:[],
vcn_reference:'',amountpaid:0,paid:'paid',
	creditdate:'',productviewData:[],sestatus:'',vcn_id:'',outstandingamt:0,ve_id:0,
	 VendorData:[],page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],Grndtotal:0,
search:'',order:'desc' ,orderBy:'vcn_id',customername:'',taxbrkupsarr:[],taxsumarr:[],subtotal:"0.00",
	  goodthrudate:'',erropen:false,errortype:"error",errormessage:"",grandtotal:"0.00",
	urllink:'',	activeStep:0,active:'',setactiveStep:0,vcn_status:0,paycount:0,paytext:"payments",PaymnetData:[],totalamount:0,lastdate:'',paidtext:'PAID',
		
	}
	  this.updateDonenewParent=this.updateDonenewParent;          
	}
	
	
 updateDonenewParent = (event) => {
	 this.VendorcreditnoteViewmore();
	 
 }
	
componentWillMount() { 
if(localStorage.getItem("ISIuserid")==null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	  this.VendorcreditnoteViewmore();
	

	  
	
	}
 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



Productapicall(vcnid){


	axios.get(localStorage.getItem("ISIurl")+'ajaxvendorcreditnoteproduct.php?action=getall&vcnp_vcn_id='+vcnid)
     
  .then(resp => {  	
    if(resp.data.length>0){
			let strgrandtotal=0;
				let optionstaxRep = resp.data;
				optionstaxRep.forEach(eachrep => {
					strgrandtotal=parseFloat(strgrandtotal)+parseFloat(eachrep.total);
				});
			this.setState({  
			  productviewData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   Grndtotal:strgrandtotal,outstandingamt:strgrandtotal
			   
			},()=>{
				
			 this.GetTotalById(vcnid);
					
				});
				
			

     }
	 
	  else{
		   this.setState({productviewData:[],totaldata:0});
	 }
	 
  
    });
}

 




VendorcreditnoteViewmore() {
    let search = window.location.href;
    let Vcnid = this.getParameterByName('vcnid', search);

    axios.get(localStorage.getItem("ISIurl") + 'ajaxvendorcreditnote.php?action=getall&vcn_id=' + Vcnid)
        .then(resp => {
            if (resp.data.length > 0) {
              
                let strname = "Vendor Credit Note";

                this.props.parentdasCallback(strname + "~");

               
                this.setState({
                    VendorData: resp.data,
                    vcn_id:resp.data[0].vcn_id,
                    ve_id:resp.data[0].ve_id,
                    vcn_billingaddress1: resp.data[0].vcn_billingaddress1,
                    vcn_billingaddress2: resp.data[0].vcn_billingaddress2,
                    vcn_billingcity: resp.data[0].vcn_billingcity,
                    vcn_billingpincode: resp.data[0].vcn_billingpincode,
                    vcn_billingstate: resp.data[0].vcn_billingstate,
                    ve_contactname: resp.data[0].ve_contactname,
                    vcn_creditdate: resp.data[0].vcn_creditdate,
                    creditdate: resp.data[0].creditdate,
                    vcn_reference: resp.data[0].vcn_reference,
                    vcn_status: resp.data[0].vcn_status,
                });

               
                this.Productapicall(Vcnid);
				
				
				
				
				
			
            }

			else {
                
                this.setState({ VendorData: [] });
            }
			
			
        });
		
		
		
		
}


 handlAddfileopen = () => {
	
	this.refs.Uploadfile.handleaddfileClose();
}

 handleAddpayment = () => {
	
	this.refs.Payment.handleaAddpaymentClose();
}





   handlemailopen = () => {
        const currentUrl = window.location.href; 
        this.setState({ urllink: currentUrl });
        this.setState({ open: true }); 
    }; 
	
	
	   handleCopyLink = () => {
        
        navigator.clipboard.writeText(this.state.urllink)
            .then(() => {
                alert('Link copied!');
this.setState({open:false});				
            })
           
    };
	




 
   

 
  




handleClickOpen = (e) => { 
  this.setState({open:!this.state.open
	  });
		
};



handleaddfileClose = (e) => { 
  this.setState({addopen:!this.state.addopen,
	  });
	 		
}

handlestatusupdate = (e) =>{

  let r = window.confirm("Do you really want to Dispute?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 formData.append('action','statusupdate')
					formData.append('vcn_id',this.state.vcn_id)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					 formData.append('vcn_status',8)
				
					  axios.post(localStorage.getItem("ISIurl")+"ajaxvendorcreditnote.php", 
					  formData, {}).then(res => {
						   this.setState({erropen: true,errormessage:'Status has been Updated',errortype:"success"}); 
						  this.VendorcreditnoteViewmore();
	                     })
		 
		 }
	
}





handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }


DeleteVendorCreditnote = (e) =>{  
  
 
	
		let r = window.confirm("Do you really want to Delete?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 formData.append('action','delete')
					
					 formData.append('vcn_id',this.state.vcn_id)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
				
					   axios.post(localStorage.getItem("ISIurl")+"ajaxvendorcreditnote.php", 
					  formData, {}).then(res => {
						  
						  this.setState({redirect: true,pagename:'/#/Adminvendorcreditnote'});  
	                     })
						
		 }
 }




GetTotalById(vbid) {
  axios.get(localStorage.getItem("ISIurl") + 'ajaxpayments.php?action=gettotal&pmt_type=4&pref_mainid=' + vbid)
    .then(resp => {
      if (resp.data.length > 0) {
     

        this.setState({
        lastdate:resp.data[0].lasttransaction,
        totalamount:resp.data[0].totalpaid,
		outstandingamt:parseFloat(this.state.outstandingamt)-parseFloat(resp.data[0].totalpaid),
      paycount:resp.data[0].cnt,

	  });
      } 
	  
	  
	  
	  
	  else {
        this.setState({ totalamount: 0 });
      }
	  
	  
	  
    });
}





/**/




 
   addpayrefbox(){
    let search = window.location.href;
   
    setTimeout(() => this.refs.PaymentRefBox.handleClickOpen(),500);

 }
 
 
 
 

	render() {
		
		  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	
let grandTotal=0;
		let subtaotal = 0;
		let totalitem=0;
		let outstandingamount=0;
		
		let balanceamoutn=0;
    return (
	
<React.Fragment>	


<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  
	  
	
	  <div className="paidgreebbox">
	  <p>{this.state.paidtext}</p>
	  
	  </div>
	
	  
	  
	  
	  
	  
  <div className="estimateviewcontainer">
    <div className="estimateviewerleftbox">

        <div className="custgreencolor">
          To: <span className="lighgreencolor">{this.state.ve_contactname}</span>
        </div>
        
        <div className="estaddressdata">
          <Table width="100%">
            <tr>		
              <td align="left" style={{"width": "10%"}}>	
                {this.state.VendorData.map((item,index) => { 
                  return (
                    <React.Fragment>
                      <div className="invoiceaddress">
                      
                          <p><b>Address</b> </p>
                           <p>{item.vcn_billingaddress1}
                          {item.vcn_billingaddress2}<br/>
                          {item.vcn_billingcity} <br/>
						  
						{item.vcn_billingstate} - {item.vcn_billingpincode}<br/>
                          
                       </p>
                      </div>
                    </React.Fragment>
                  );
                })}
              </td>
             <td align="left" style={{"width": "10%"}}> 
                <p><b>Credit Date</b></p>
                <p>{this.state.creditdate}</p>
              </td>

              

              <td align="left" style={{ width: "10%" }}>
                {this.state.vcn_reference && (
                  <>
                    <p><b>Reference</b></p>
                    <p>{this.state.vcn_reference}</p>
                  </>
                )}
              </td>
         

            </tr>
          </Table>
        </div>
        
		

	
	<PaymentRefBox 
ref="PaymentRefBox"   pmt_type={4}
outstandingamt={this.state.outstandingamt}

pref_mainid={this.state.vcn_id}

/>
  <Payment ref="Payment" 
cu_id={this.state.ve_id}
          pref_mainid={this.state.vcn_id}

          vb_status={this.state.vb_status}
       Grndtotal={this.state.outstandingamt}
updateDonenew={this.updateDonenewParent}
			   pmt_type={4}/>
		
		
        <div ref={el => (this.componentRef = el)}  >
          <Paper>
            <TableContainer className="table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head" style={{"width":"40%"}} >Product</TableCell>
                    <TableCell className="table-head" style={{"width":"40%"}} >Item Description</TableCell>
                    <TableCell className="table-head" style={{"width":"5%"}}>Qty</TableCell>
                    <TableCell className="table-head " style={{"width":"10%"}}>Price</TableCell>
                    <TableCell className="table-head " style={{"width":"20%"}}>Total</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {this.state.productviewData.map((item, index) => {
                   
					
				   
                    return (
                      <React.Fragment key={index}>
                        <TableRow className="table-cell" style={{ backgroundColor: '#f1f5f6' }}>
                          <TableCell className="table-cell">
                           
                            <p><i>{item.pr_code})</i></p>
                          </TableCell>
                          <TableCell className="table-cell">{item.pr_description}</TableCell>
                          <TableCell className="table-cell">{item.qty} </TableCell>
<TableCell className="table-cell">{Number(item.salesprice || 0).toFixed(2)}</TableCell>                          
<TableCell className="table-cell">
  <p>{Number(item.total || 0).toFixed(2)}<br />{item.tx_name}</p>
</TableCell>                         
                        </TableRow>
                      </React.Fragment>
                    );
                  })}


		 {this.state.productviewData.length>0 &&(
				  <React.Fragment>
                  <TableRow>
                    <TableCell colSpan="3"></TableCell>
                    <TableCell><b> Total</b></TableCell>
<TableCell align="left">
  <b>$ {Number(this.state.Grndtotal || 0).toFixed(2)}</b>
</TableCell>                  </TableRow></React.Fragment>
		 )}
				 
				  
				    
				  {this.state.productviewData.length===0 &&(
				  
                 <TableRow>
                 <TableCell  >
                  No Products Found
                  </TableCell>
                </TableRow>

				  
				  
				  )}
				  
				  
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
       </div>
      
    </div>

    <div className="estimateviewerightbox">
      
	  <div className="invoiceupdatebox">
	  
	
		<div className="stepperheader">		
		
		<div className="amountpaidbox">
		
		<p><b>Amount Paid</b></p>
		
		
		<h4><b>$ {Number(this.state.totalamount || 0).toFixed(2)}</b></h4>
	  {this.state.totalamount!=0 && (
		<p><span className="greentextcolor">{this.state.paycount}&nbsp;
	
		<span className="paytext" onClick={()=>{this.addpayrefbox()}}>{this.state.paytext}</span> 	&nbsp;</span> on {this.state.lastdate}</p>
	  )}
	
		</div>
		
		
		<div className="outstadingpaybox">
		
		<p><b>Amount Outstanding</b></p>
		<h4><b>$ {Number(this.state.outstandingamt || 0).toFixed(2)}</b></h4>
		
		</div>
		
		<div className="clear"></div>
	   </div>
	   {(this.state.vcn_status!=="4" && this.state.vcn_status!=="1") && (
		<div className="createinvoicebox">
		  <h3  onClick={this.handleAddpayment}>Record Refund </h3>
		  
		</div>
	   )}
	  
	  </div>
	  
	  
	  
	  
	  <div className="invoiceupdatebox">
	  
		
		   <div className="Viewfunctionality">
            <ul>
           {this.state.vcn_status!=="4" && (
			 <li>
            <p className="icon-text">
             <a href={'/#/Addvendorcreditnote?vcnid='+this.state.vcn_id} >  <EditOutlinedIcon className="verticalalign"/> &nbsp; Edit</a>
            </p>
             </li>
			  )}
			     <li>
            <p className="icon-text"> <a href={'/#/Addvendorcreditnote?vcnid='+this.state.vcn_id+'&copy=1'} >
              <ContentCopyOutlinedIcon className="verticalalign"/>&nbsp; Copy</a>
            </p>
			</li>
			 	 <li>
            <p className="icon-text" onClick={this.handlAddfileopen}>
            <AttachFileOutlinedIcon className="verticalalign"/> &nbsp; Add file
          </p>

             </li>
			 
			 
			 {this.state.vcn_status!=="8" && (
			 
			     <li>
            <p className="icon-text"> 
              <InfoSharpIcon   onClick={this.handlestatusupdate} className="verticalalign"/>&nbsp; Dispute
            </p>
			</li>
			 )}
			 
			
			 
		
	
			 
			 
			

       {this.state.vcn_status!=="4" && (
     
			<li>
            <p className="icon-text">
              <a  
	onClick={this.DeleteVendorCreditnote}
               
                rel="noreferrer"  > <DeleteOutlineOutlinedIcon className="verticalalign"/>&nbsp; Delete</a>
            </p>
			</li>
		  )}
			 
			
             </ul>
               </div>

	  </div>
	  
	  
	  
    </div>
  </div>

  <div className="clear"></div>
  

  
  
  <div className="sharedialogue">
  
<Dialog
    open={this.state.open}
    onClose={this.handleClose}
    maxWidth="xs"
    fullWidth={true}
  >
    <DialogTitle id="form-dialog-title" className="dialoghead">
  
    </DialogTitle>
    <DialogContent>
	
	
	<p><TextField
	fullWidth
	value={this.state.urllink}
    InputLabelProps={{shrink: true }}
    ref={this.usernameInput}
	inputProps={{ tabIndex: "10",maxLength:100  }} 
            />
	</p>
	
	
   <React.Fragment>
    <div className="actionbtns">
     <div className="cancelbtn">
            <Button variant="contained" className="frmthirdbtn" onClick={this.handleClickOpen}>
              Close
            </Button>
          </div>
          <div className="savebtn">
            <Button variant="contained" className="frmSecondarybtn" onClick={this.handleCopyLink}>
              copy link
            </Button>
          </div>
          <div className="clear"></div>
        </div>
      </React.Fragment>
    </DialogContent>
  </Dialog>
  
</div>
  


			   <Uploadfile ref="Uploadfile" id={this.state.vcn_id}  strrtype={4}/>

  
  
  
  
  
  
  
</React.Fragment>
    );
}

}




  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  